import { render, staticRenderFns } from "./sso-clever.vue?vue&type=template&id=55456fce&scoped=true&"
import script from "./sso-clever.ts?vue&type=script&lang=ts&"
export * from "./sso-clever.ts?vue&type=script&lang=ts&"
import style0 from "./sso-clever.scss?vue&type=style&index=0&id=55456fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55456fce",
  null
  
)

export default component.exports